<template>
    <el-container class="home-login">
        <!-- body -->
        <el-main>
            <div class="login-content">
                <span slot="title" class="dialog-title clearfloat">
                    <div class="dialog-logo">
                        <i class="logo">
                            <img class="logo-style" id="logo-img" :src="logoImageUrl" type="image/svg+xml"/>
                        </i>
                        <h4 class="website">
                            bibite<span style="color: #db5634">.COM</span>
                        </h4>
                    </div>
                    <div class="description">
                        <!-- <p>全球量化交易平台</p> -->
                        <!-- <span @click="flag = true" :class="{'myblue': flag == true}"><a>单边</a></span> -->
                        <!-- <span @click="flag = false" :class="{'myblue': flag == false}"><a>套利</a></span> -->
                    </div>
                </span>
                <div class="component">
                    <LoginS v-if="flag == true"></LoginS>
                    <Login v-else></Login>
                </div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
import Login from '@/components/Login.vue'
import LoginS from "@/components/login/Login-single.vue";

export default {
    components: {
        Login,
        LoginS
    },
    data() {
        return {
            centerDialogVisible: false,
            userName: '',
            password: '',
            flag: false,
            logoImageUrl: require('../../assets/img/lianghualogo.svg'),
        }
    },
}
</script>

<style lang="scss" scoped>
    .home-login{
        background-color: #1e1e1e;
        display: flex;
        height: 100%;
        text-align: center;
        .el-main{
            background-color: #252425;
        }
        .login-content{
            height: 450px !important;
            width: 25%;
            background-color: #252425;
            border-radius: 5px;
            margin: 0;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translateY(-50%) translateX(-50%);
            box-shadow: 0 0 0 #000;
            .component{
                margin: 10px 0;
                border: 0;
            }
            .dialog-btn{
                margin: 10px 0 0 0;
                padding: 5px;
                span{
                    padding: 10px 10px;
                    color: #807c7c;
                    font-weight: 600;
                    border-bottom: 2px solid #807c7c;
                }
                span:hover{
                    cursor: pointer;
                }
            }
            .dialog-logo{
                padding: 15px;
                background-color: #252425;
                #logo-img{
                    width: 30%;
                }
                h4{
                    color: #fff;
                }
                .website{
                    font-size: 1.7rem;
                }
            }
            .description{
                color: #6f6f6f;
            }
        }
    }
    .myblue{
        color: #eb602e !important;
        border-bottom: 2px solid #eb602e !important;
    }
    @media screen and (max-width: 1500px) {
        .login-content{
            width: 436px !important;
        }
    }
    @media screen and (max-width: 1200px) {
        .login-content{
            width: 436px !important;
        }
    }
    @media screen and (max-width: 900px) {
        .login-content{
            width: 350px !important;
        }
    }
</style>
